import { c as _c } from "react/compiler-runtime";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { ProjectMarkupsTableHeaders } from "@pages/project-details/project-markups/project-markups-table-utils";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
const DUE_DATE_COLUMN = ProjectMarkupsTableHeaders.dueDate;

/**
 * Removes the due date filters from the URL that are not offered, e.g. a mistyped date in a link.
 * Annotations pass no filter that is not offered, so the table would otherwise be left empty.
 */
export function useRemoveUnknownDueDateFilters(dueDateFilters) {
  const $ = _c(8);
  const {
    getFilterIdsForColumn
  } = useFilterQueryParams();
  let t0;
  if ($[0] !== dueDateFilters || $[1] !== getFilterIdsForColumn) {
    t0 = dueDateFilters !== undefined && getFilterIdsForColumn(DUE_DATE_COLUMN).some(filterId => !(filterId in dueDateFilters));
    $[0] = dueDateFilters;
    $[1] = getFilterIdsForColumn;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const hasUnknownFilterIds = t0;
  const [, setSearchParams] = useSearchParams();
  let t1;
  let t2;
  if ($[3] !== dueDateFilters || $[4] !== hasUnknownFilterIds || $[5] !== setSearchParams) {
    t1 = () => {
      if (!hasUnknownFilterIds || dueDateFilters === undefined) {
        return;
      }
      setSearchParams(searchParams => {
        const knownFilterIds = searchParams.getAll(DUE_DATE_COLUMN).filter(filterId_0 => filterId_0 in dueDateFilters);
        searchParams.delete(DUE_DATE_COLUMN);
        knownFilterIds.forEach(filterId_1 => searchParams.append(DUE_DATE_COLUMN, filterId_1));
        return searchParams;
      }, {
        replace: true
      });
    };
    t2 = [dueDateFilters, hasUnknownFilterIds, setSearchParams];
    $[3] = dueDateFilters;
    $[4] = hasUnknownFilterIds;
    $[5] = setSearchParams;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
}